import React, { Component, useState, useEffect, useRef } from 'react'
import './Obhodnoilist.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import './SpravkaObObuch.css'
import QRCode from 'qrcode.react';
import dayjs from 'dayjs'
import fetchJSON from "../../../fetchData";
import { useReactToPrint } from "react-to-print";

export const StudingReportQR = () => {
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const [language, setLanguage] = useState(1)
    const currentDate = useState(dayjs(new Date()).format('DD.MM.YYYY'))
    const [Studing, setStuding] = useState([])
    const st = new URLSearchParams(window.location.search).get("st");
    const gr = new URLSearchParams(window.location.search).get("gr");
    const fct = new URLSearchParams(window.location.search).get("fct");

    useEffect(() => {
        postStudingReport(gr, st, fct)
    }, [])

    const postStudingReport = async (id_group, id_student, id_faculty) => {
        const json = await fetchJSON('studing', 3928, { id_group, id_student, id_faculty })
        if (json) {
            setStuding(json.Studing)
        }
    }

    const OpenReportsPage = (reportsPage, reportType) => {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    const selectLanguage = (language) => {
        setLanguage(language)
    }

    return (
        <div className='ObhodnoiList D_main_header' >
            <header>
                <i className="fas fa-arrow-left" onClick={() => OpenReportsPage(0, 0)}></i>
                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                {language === 1 ? <h2> Справка об обучении</h2> : <h2>Окугандыгы тууралуу маалымат</h2>}
                <div className='Language'>
                    <h4 onClick={() => selectLanguage(1)} className={language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                    <h4 onClick={() => selectLanguage(2)} className={language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                </div>
            </header>

            {language === 1 ?
                // На русском языке
                <div className="A4 SpravkaObObuch" ref={componentRef}>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].mo}</h3>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].v2}</h3>
                    {Studing && Studing.length && Studing[0].length && Studing[0][0].faculty?.length ? <h4>{Studing[0][0].faculty}</h4> : null}
                    <h1>{`СПРАВКА № 2-${gr}-${st}-${fct}`}</h1>
                    <p style={{ marginTop: '15px' }}>Настоящая справка подтверждает то, что</p>
                    <h5>{Studing && Studing.length && Studing[1].length && Studing[1][0].s_fio}</h5>
                    <p>
                        {`действительно является ${Studing && Studing.length && Studing[1].length && Studing[1][0].Male == 1 ? 'студентом' : 'студенткой'} ${Studing && Studing.length && Studing[1].length && Studing[1][0].id_rate}-курса группы 
                        ${Studing && Studing.length && Studing[1].length && Studing[1][0].p20}
                        ${Studing && Studing.length && Studing[1].length && (Studing[1][0].p108.includes('бакалавр') || Studing[1][0].p108.includes('магистратур')) ? 'направления ' : 'специальности '}   
                        "${Studing && Studing.length && Studing[1].length && (Studing[1][0].p108.includes('бакалавр') || Studing[1][0].p108.includes('магистратур')) ? Studing && Studing.length && Studing[2].length && Studing[2][0].direction : Studing && Studing.length && Studing[2].length && Studing[2][0].special}"
                        (${Studing && Studing.length && Studing[1].length && Studing[1][0].p108}).`}
                    </p>
                    <p style={{ marginTop: '24px', textAlign: 'left', padding: '0 110px' }}>
                        {`Общий срок обучения: ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id} ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id > 4 ? 'лет' : 'года'}.`}
                    </p>
                    <p style={{ marginTop: '26px' }}>Справка выдана по месту требования.</p>
                    <div className="podpisi">
                        <div>
                            <QRCode
                                id="qrCodeEl"
                                value={window.location.href} />
                            <h5>{currentDate} г.,
                                {/* {this.props.user_fio} */}
                                {/* {this.props.doljnost} */}
                            </h5>
                        </div>
                        <div>
                            <h4 >{Studing && Studing.length && Studing[3].length && Studing[3][0].insert_pole}</h4>
                            <h4 >{Studing && Studing.length && Studing[4].length && Studing[4][0].insert_pole}</h4>
                        </div>
                    </div>

                </div> :

                // На кыргызском языке
                <div className="A4 SpravkaObObuch" ref={componentRef}>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].mo}</h3>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].v2}</h3>
                    {Studing && Studing.length && Studing[0].length && Studing[0][0].faculty?.length ? <h4>{Studing[0][0].faculty}</h4> : null}
                    <h1>{`СПРАВКА № 2-${gr}-${st}-${fct}`}</h1>
                    <p style={{ marginTop: '15px' }}>Настоящая справка подтверждает то, что</p>
                    <h5>{Studing && Studing.length && Studing[1].length && Studing[1][0].s_fio}</h5>
                    <p>
                        {`действительно является ${Studing && Studing.length && Studing[1].length && Studing[1][0].Male == 1 ? 'студентом' : 'студенткой'} ${Studing && Studing.length && Studing[1].length && Studing[1][0].id_rate}-курса группы 
                        ${Studing && Studing.length && Studing[1].length && Studing[1][0].p20}
                        ${Studing && Studing.length && Studing[1].length && (Studing[1][0].p108.includes('бакалавр') || Studing[1][0].p108.includes('магистратур')) ? 'направления ' : 'специальности '}   
                        "${Studing && Studing.length && Studing[1].length && (Studing[1][0].p108.includes('бакалавр') || Studing[1][0].p108.includes('магистратур')) ? Studing && Studing.length && Studing[2].length && Studing[2][0].direction : Studing && Studing.length && Studing[2].length && Studing[2][0].special}"
                        (${Studing && Studing.length && Studing[1].length && Studing[1][0].p108}).`}
                    </p>
                    <p style={{ marginTop: '24px', textAlign: 'left', padding: '0 110px' }}>
                        {`Общий срок обучения: ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id} ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id > 4 ? 'лет' : 'года'}.`}
                    </p>
                    <p style={{ marginTop: '26px' }}>Справка выдана по месту требования.</p>
                    <div className="podpisi">
                        <div>
                            <QRCode
                                id="qrCodeEl"
                                value={window.location.href} />
                            <h5>{currentDate} г.,
                                {/* {this.props.user_fio} */}
                                {/* {this.props.doljnost} */}
                            </h5>
                        </div>
                        <div>
                            <h4 >{Studing && Studing.length && Studing[3].length && Studing[3][0].insert_pole}</h4>
                            <h4 >{Studing && Studing.length && Studing[4].length && Studing[4][0].insert_pole}</h4>
                        </div>
                    </div>

                </div>}

        </div>
    )
}


